module.exports = __webpack_public_path__ + "static/02_Dr-Princenthal-with-Screens-bab29b6e75b281bd0f26e9a1bba1b2df.jpg";